import AdminHeader from 'components/atoms/adminHeader';
import LongRectangleTextButton from 'components/atoms/longRectangleTextButton';
import GroupList from 'components/molecules/groupList';
import NavigationAdmin from 'components/organisms/navigationHeaderWebTabs';
import NavigationHeaderWeb from 'components/organisms/navigationWeb/index.web';
import {
  useAdminGroupsStore,
  useAdminGroupsStudentsStore,
  useLoaderStore,
} from 'contexts/StoreContext';
import {useTheme} from 'contexts/ThemeContext';
import {observer} from 'mobx-react';
import {AdminPanelGroupsScreenProps} from 'navigations/GroupsFlow';
import {Flows, ScreenName} from 'navigations/Screens';
import React, {useEffect} from 'react';
import {ScrollView, View} from 'react-native';
import strings from 'translations/index.web';
import styleSheet from './styles';

const AdminPanelGroups = observer((props: AdminPanelGroupsScreenProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  const groupsStore = useAdminGroupsStore();
  const studentsStore = useAdminGroupsStudentsStore();

  const groupData = groupsStore.groups;

  useEffect(() => {
    groupsStore.getGroups();
  }, []);

  const handleDelete = async (id: string) => {
    await groupsStore.deleteGroup(id);
  };

  const onPressEdit = async (id: string) => {
    props.navigation.navigate(ScreenName.adminPanelGroupsInteraction, {
      title: strings.admin.editGroup,
      id: id,
    });
  };

  const onPressCreateGroup = () => {
    props.navigation.navigate(ScreenName.adminPanelGroupsInteraction, {
      title: strings.admin.createGroup,
    });
  };

  return (
    <ScrollView style={styles.container}>
      <NavigationHeaderWeb activeName={Flows.adminPanelGeneralFlow} />
      <NavigationAdmin activeName={Flows.adminPanelGroupsFlow} />
      <View style={styles.infoContainer}>
        <AdminHeader title={strings.admin.group}>
          <LongRectangleTextButton
            onPress={onPressCreateGroup}
            title={strings.admin.createGroup}
            buttonStyle={styles.buttonStyle}
            titleColor={styles.titleColor}
          />
        </AdminHeader>
        <GroupList
          flatListData={groupData}
          onPressDelete={handleDelete}
          onPressEdit={onPressEdit}
        />
      </View>
    </ScrollView>
  );
});

export default AdminPanelGroups;
